import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description?: string;
}

function setMetaContent(selector: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, attr, name] = selector.match(/^meta\[([a-z]+)="([^"]+)"\]$/) || [];
    if (attr && name) {
      el.setAttribute(attr, name);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[name="twitter:title"]', title);
    if (description) {
      setMetaContent('meta[name="description"]', description);
      setMetaContent('meta[property="og:description"]', description);
      setMetaContent('meta[name="twitter:description"]', description);
    }
    return () => {
      document.title = previousTitle;
    };
  }, [title, description]);
}
